const messages = {
    buttons: {
        productBrochures: "Atklāt",
    },
    index: {
        title: "PRODUKTA INFORMĀCIJA",
        description: "Lejupielādējiet šeit jaunākās mūsu Bridgestone un Firestone riepu brošūras un skrejlapas.",
        categories: {
            productBrochures: {
                title: "Produktu brošūras",
                description: "Bridgestone un Firestone riepu sēriju brošūras",
            },
            bDrive: {
              title: "Produktu attēli",
              description: "Aktuālos attēlus varat lejupielādēt mūsu B-DRIVE portālā.",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

